<template>
  <v-form
		id="newSurveyForm"
		class="pa-5" 
		ref="form"
		v-model="valid"
		lazy-validation

  >
	<v-row>
		<v-col>
			<v-text-field v-model="name" label="Survey Name" v-on:keydown.enter="createSurvey"></v-text-field>
		</v-col>
	</v-row>
    <v-btn
		color="error"
		class="mr-4"
		@click="reset"
    >
		Reset Form
    </v-btn>

    <v-btn
		:disabled="!valid"
		color="success"
		class="mr-4"
		@click="createSurvey"
    >
		Create Survey
    </v-btn>
  </v-form>
</template>

<script>
export default {
  name: 'NewSurveyForm',
  data: () => (
	{
		valid: true,
		name: '',
		text: '',
    }),
	methods: {
		createSurvey () {
			event.preventDefault();
			var self = this;
			let newSurvey = { 
					"publishStatus": "live",
					'name': this.name,
			}
			self.$store.dispatch( "addDoc", {
				collection: "surveys",
				data: newSurvey
			} ).then( function( ref ){
				self.$store.dispatch("bindAnything", {id: ref.id, collection: "surveys", then: "SET_ANYTHING", reference: "surveys"} )
				self.$refs.form.reset();
				self.$emit("created", ref.id, "survey" )

			} );

		}, 
		reset: function(){
			this.$refs.form.reset();
		}
	},
};
</script>
